<template>
    <section class="gmp-section gmp-mb-l">

        <div class="two-column-text">
            <div class="h-c-page">

                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                快速分拣和称重
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>
                                    系统能够根据所有客户的订货商品进行统计分析，并在出库模块中显示库存商品。
                                    这意味着配送商可以快速按照客户或商品分类，轻松进行分拣和称重，大大提高了订单处理的效率。
                                </p>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                简化出库流程
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>记录分析库存数量变化，保鲜期的报警，废弃率统计.</p>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                便捷的外部采购
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>
                                    对于需要对外采购的商品，系统通过微信分享的功能，将采购订单分享给其他供货商。
                                </p>
                            </div>
                        </div>
                    </div>

                </div>


                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                定价灵活性
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>配送商在收到其他供货商的商品数量和出货价信息后，可以根据市场情况灵活定价，确保利润最大化，同时保持竞争力。</p>

                            </div>
                        </div>
                    </div>

                </div>



            </div>
        </div>

    </section>
</template>

<script>
    export default {
        name: "DIS_two_column_text"
    }
</script>

<style lang="less">


</style>